import React from "react";
import { Skeleton } from "antd";
import { Row, Col, Container } from "reactstrap";
import TableSkeleton from "./TableSkeleton";

const CustomerDetailsSkeleton = () => {
    return (
        <Container className="mt-4">
            {/* Header section skeleton */}
            <div className="mb-4 d-flex justify-content-between align-items-center">
                <Skeleton.Button active size="large" style={{ width: 250 }} />
                <div className="d-flex gap-3">
                    <Skeleton.Button active size="default" style={{ width: 100 }} />
                    <Skeleton.Button active size="default" style={{ width: 80 }} />
                </div>
            </div>

            {/* Top Cards: Billing/Info (lg: 5) & Payment/Preferences (lg: 7) */}
            <Row className="mb-5 gy-4">
                <Col lg={5}>
                    <div className="p-4 bg-white rounded-16 shadow-sm border h-100" style={{ minHeight: '350px' }}>
                        <Skeleton active paragraph={{ rows: 6 }} title={{ width: 150 }} />
                    </div>
                </Col>
                <Col lg={7}>
                    <div className="p-4 bg-white rounded-16 shadow-sm border h-100" style={{ minHeight: '350px' }}>
                        <Skeleton active paragraph={{ rows: 6 }} title={{ width: 200 }} />
                        <div className="mt-4">
                            <Skeleton active paragraph={{ rows: 2 }} title={false} />
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Middle Section: Orders / Related Table */}
            <Row className="mb-5">
                <Col md={12}>
                    <div className="p-4 bg-white rounded-16 shadow-sm border">
                        <Skeleton.Button active size="large" style={{ width: 200, marginBottom: '20px' }} />
                        <TableSkeleton columns={8} />
                    </div>
                </Col>
            </Row>

            {/* Bottom Section: Log Table */}
            <Row className="mb-4">
                <Col md={12}>
                    <div className="p-4 bg-white rounded-16 shadow-sm border">
                        <Skeleton.Button active size="large" style={{ width: 150, marginBottom: '20px' }} />
                        <Skeleton active paragraph={{ rows: 4 }} title={false} />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default CustomerDetailsSkeleton;
